import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { Link, useParams } from "react-router-dom";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";

export default function ClientRecharge({ refreshKey }) {
    const params = useParams();
    const [lists, setLists] = useState([]);
    const [loadingStates, setLoadingStates] = useState({});

    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "Content-Type": "application/json"
        }
    }

    const handleSubmit = (e, data) => {
        e.preventDefault();
        // Set loading state only for this specific item
        setLoadingStates(prev => ({ ...prev, [data.creditUsagePriceId]: true }));

        axios.post(config.APIACTIVATEURL + config.CLIENTRECHARGE +
            "?UsageType=" + data.usage +
            "&Count=" + data.totalCount +
            "&UserId=" + localStorage.getItem("userId") +
            "&Credits=" + data.totalCredits,
            { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    handleSuccess(response.data.message);
                    refreshKey();
                } else {
                    handleError(response.data.message);
                }
            })

            .finally(() => {
                // Reset loading state for this specific item
                setLoadingStates(prev => ({ ...prev, [data.creditUsagePriceId]: false }));
            });
    };

    const GetData = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETCREDITUSAGEPRICES + "?pageNumber=1&pageSize=50", { ...headerconfig })
            .then((response) => {
                if (response.status === 200) {
                    setLists(response.data.data.data);
                }
            });
    };

    useEffect(() => {
        if (localStorage.getItem('clientId') !== null) {
            GetData(1);
        }
    }, [refreshKey])

    return (
        <div className="card">
            <div className="card-header bg-soft-danger">
                <h5 className="text-black mb-0">Recharge</h5>
            </div>
            <div className="card-body">
                <div className="table-responsive table-card">
                    <table className="table align-middle" id="customerTable">
                        <thead className="table-light">
                            <tr>
                                <th>Id</th>
                                <th>Usage</th>
                                <th>Credits</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody className="list form-check-all">
                            {lists.length > 0 && lists.map((v, index) =>
                                <tr key={v.creditUsagePriceId}>
                                    <td>{index + 1}</td>
                                    <td>{v.totalCount} {v.usage}</td>
                                    <td>{v.totalCredits} Credit(s)</td>
                                    {v.usage !== "BANK STATEMENTS" && v.usage !== "APPLICATION" ?
                                        <td>
                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={(e) => handleSubmit(e, v)}
                                                disabled={loadingStates[v.creditUsagePriceId]}
                                            >
                                                {loadingStates[v.creditUsagePriceId] ? "Processing..." : "Recharge Now"}
                                            </button>
                                        </td> : <td></td>}
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}